import * as React from 'react';

import { cn } from '../lib/cn';

export interface TopbarProps extends React.HTMLAttributes<HTMLDivElement> {
  leftSlot?: React.ReactNode;
  centerSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
}

export const Topbar = React.forwardRef<HTMLDivElement, TopbarProps>(
  ({ className, leftSlot, centerSlot, rightSlot, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex h-14 w-full items-center gap-2 px-3 md:gap-3 md:px-4',
          className,
        )}
        {...props}
      >
        {leftSlot ? (
          <div className="flex items-center gap-2">{leftSlot}</div>
        ) : null}
        {centerSlot || children ? (
          <div className="flex flex-1 items-center justify-center min-w-0">
            {centerSlot ?? children}
          </div>
        ) : (
          <div className="flex-1" />
        )}
        {rightSlot ? (
          <div className="flex items-center gap-1.5 md:gap-2">{rightSlot}</div>
        ) : null}
      </div>
    );
  },
);
Topbar.displayName = 'Topbar';
